<!--
 * @FilePath: \zsw_new_edition\src\components\navComeDown\SuComeDown.vue
 * @Brief: 文件说明
 * @Version: 1.0
 * @Date: 2021-11-25 14:21:10
 * @Author: M
 * @Copyright: @M copyright description
 * @LastEditors: M
 * @LastEditTime: 2022-03-03 09:26:35
-->
<!--方案文本下拉框组件-->
<template>
  <div class="comeDownBox">
    <div class="imgBox">
      <a target="_blank" :href="comeDownBanner.url">
        <img :src="comeDownBanner.src" alt="" />
      </a>
    </div>
    <div class="contentBox">
      <ComeDownMiddle  :link="link" :classList="classList"></ComeDownMiddle>
    </div>
		<div class="recommendBox">
			<div v-for="(item, index) in recommendList" :key="index">
				<router-link
					:to="{ path: '/schemeText/index?search=' + item.title }"
					target="_blank"
				>
					<img :src="item.src" alt="" />
				</router-link>
			</div>
		</div>
  </div>
</template>

<script>
import ComeDownMiddle from "@/components/navComeDown/ComeDownMiddle";
import { getBanner,getNavigation } from "../../Api";

export default {
  name: "SchemeTextComeDown",
  props:[
    "link"
  ],
  data(){
    return {
      comeDownBanner:"",
      classList:"",
			recommendList: []
    }
  },
  components: {
    ComeDownMiddle,
  },
  created() {
    getBanner({
      position: 2368,
    }).then((res) => {
      this.comeDownBanner = res.data[0];
      this.recommendList = res.data.slice(1, 9);
    });
    getNavigation(1394).then((res) => {
      this.classList = res.data;
      console.log(res)
    });
  },
};
</script>

<style scoped>
.comeDownBox {
  height: 4.27rem;
  background: #ffffff;
  box-shadow: 0px 0px 40px rgba(184, 184, 184, 0.16);
  opacity: 1;
  display: flex;
  padding: 0.3rem 2.8rem;
	justify-content: space-between;
}
.imgBox {
  width: 2.48rem;
  height: 3.67rem;
  border-radius: 8px;
  margin-right: 0.4rem;
  overflow: hidden;
}

.imgBox img {
  width: 2.48rem;
  height: 3.67rem;
  border-radius: 8px;
  transition: all 0.4s;
  -moz-transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
}

.imgBox img:hover {
  transform: scale(1.2);
}

.contentBox {
  background: #ffffff;
  opacity: 1;
  border-radius: 0px;
  display: flex;
}
.recommendBox {
	width: 3.5rem;
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	justify-content: space-around;
}
.recommendBox img{
	width: 1.5rem;
	height: 0.56rem;
	object-fit: contain;
  transition: all 0.4s;
  -moz-transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
}
.recommendBox img:hover {
  transform: scale(1.2);
}
</style>